var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.dataLoading && _vm.items.length !== 0)?_c('paginate',{attrs:{"page-count":_vm.pageCount,"prev-text":'Prev',"next-text":'Next',"container-class":'pagination',"click-handler":_vm.handleChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }